import { getLogoURLByDomain } from "~/core/generic/common-utils";
import If from "~/core/ui/If";

import AvatarWithFallback from "~/components/AvatarWithFallback";
import { SearchObjectsResponse } from "~/components/GlobalCommandbar/types/common";

interface Props {
  item: SearchObjectsResponse;
}

export const AccountLabel = ({ item }: Props) => {
  return (
    <div className="flex items-center gap-2">
      <AvatarWithFallback
        src={item?.image_url || getLogoURLByDomain(item?.description)}
        alt={item?.title}
        fallbackAlt={item?.description}
        size={24}
        shape="square"
        objectType="account"
      />
      <If
        condition={
          !!item?.title &&
          !!item?.description &&
          item?.title === item?.description
        }
        fallback={
          <If
            condition={
              !!item?.title &&
              !!item?.description &&
              item?.title !== item?.description
            }
            fallback={
              <p className="text-xs">{item?.title || item?.description}</p>
            }
          >
            <p className="text-sm">{item?.title}</p>
            <p className="text-xs text-light">{item?.description}</p>
          </If>
        }
      >
        <p className="text-xs">{item?.title}</p>
      </If>
    </div>
  );
};
